import { EventEmitter } from '@angular/core';
import { ReportSectionEnum } from '../../../../models/measure/report';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { TranslateService } from '@ngx-translate/core';
import { performingInfluencerSortList, BestPerformingInfluencerSortBy } from '../../../app.constants';
import { AppSettings } from '../../../utils/app-settings';
var MeasureContentComponent = /** @class */ (function () {
    function MeasureContentComponent(pdfService, translate) {
        this.pdfService = pdfService;
        this.translate = translate;
        this.reportDataChange = new EventEmitter();
        this.reportSettingsChange = new EventEmitter();
        this.selectSorting = new EventEmitter();
        // Variables for best performing influencer sorting
        this.sortList = [];
    }
    MeasureContentComponent.prototype.ngOnInit = function () {
        this.sortList = performingInfluencerSortList;
        this.isEnableBestPerformingInfluencerSorting = AppSettings.isEnableBestPerformingInfluencerSorting();
    };
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedRoiReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.ROI_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedTimeReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.TIMELINE_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedKPIReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.KPI_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedLocalAreaReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.LOCAL_AREAS_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedMentionTimelineReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.MENTION_TIMELINE_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedExposureKpiReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.EXPOSURE_KPI_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedExposurePlalformReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.EXPOSURE_PLATFORM_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedBestExposureReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.BEST_EXPOSURE_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedSegmentationInfluencerOverviewReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.SEGMENTATION_INFLUENCER_OVERVIEW_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedSegmentationSegmentReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedSegmentationIndustryReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.SEGMENTATION_INDUSTRY_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedInsightOpportunityReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.INSIGHT_OPPORTUNITY_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedInsightBenchmarkReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.INSIGHT_BENCHMARK_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedBestPerformingReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.BEST_PERFORMING_INFLUENCER_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedInteractionReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.INTERACTION_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "isSelectedOonaReport", {
        get: function () {
            return this.moduleId === ReportSectionEnum.OONA_REPORT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureContentComponent.prototype, "titleTooltip", {
        get: function () {
            switch (this.moduleId) {
                case ReportSectionEnum.INTERACTION_REPORT:
                    return this.translate.instant('info_box.measure.interaction_title');
                case ReportSectionEnum.BEST_PERFORMING_INFLUENCER_REPORT:
                    return this.translate.instant('info_box.measure.bpi_title');
                case ReportSectionEnum.ROI_REPORT:
                    return this.translate.instant('info_box.measure.roi_title');
                case ReportSectionEnum.OONA_REPORT:
                    return this.translate.instant('info_box.measure.post_benchmark');
                case ReportSectionEnum.TIMELINE_REPORT:
                    return this.translate.instant('info_box.measure.performance_timeline');
                case ReportSectionEnum.MENTION_TIMELINE_REPORT:
                    return this.translate.instant('info_box.measure.mention_timeline');
                case ReportSectionEnum.SEGMENTATION_INFLUENCER_OVERVIEW_REPORT:
                    return this.translate.instant('info_box.measure.influencer_count');
                default:
                    return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    MeasureContentComponent.prototype.hasTransparentBackground = function () {
        return this.isSelectedKPIReport || this.isSelectedExposureKpiReport || this.isSelectedSegmentationIndustryReport;
    };
    MeasureContentComponent.prototype.onChangeReportData = function (evt) {
        this.reportDataChange.emit(evt);
    };
    MeasureContentComponent.prototype.onChangeSetting = function (evt) {
        this.reportSettingsChange.emit(evt);
    };
    MeasureContentComponent.prototype.getActivePlatformReach = function (platformReach) {
        var _this = this;
        return platformReach.map(function (pr) {
            var platform = _this.platformList.find(function (p) { return p.name.toLowerCase() === pr.name.toLowerCase(); });
            return platform ? platform.id : null;
        });
    };
    MeasureContentComponent.prototype.shouldDisplayTitle = function () {
        if (!this.pageIndex) {
            return this.title;
        }
        // in pdf mode, should not show title for duplicated page if no data
        if (this.isSelectedInteractionReport) {
            return this.pageIndex === 0 || (this.pageIndex > 0 && this.data.posts.length > 0);
        }
        else if (this.isSelectedOonaReport) {
            return this.pageIndex === 0 || (this.pageIndex > 0 && this.data.data.length > 0);
        }
        else if (this.isSelectedRoiReport) {
            return this.pageIndex === 0 || (this.pageIndex > 0 && this.data.datas.length > 0);
        }
        else {
            return this.title;
        }
    };
    MeasureContentComponent.prototype.onSelectSorting = function (evt) {
        this.selectSorting.emit(evt.id);
    };
    Object.defineProperty(MeasureContentComponent.prototype, "isSortedByReach", {
        get: function () {
            return this.selectedSortType === BestPerformingInfluencerSortBy.REACH;
        },
        enumerable: true,
        configurable: true
    });
    return MeasureContentComponent;
}());
export { MeasureContentComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-content/measure-content.component.ts.pre-build-optimizer.js